/**
 * @file SubscriptionOrderModal 内共享常量
 */

/** 空态占位图 */
export const EMPTY_ICON =
    'https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/asset/empty-content-light.png';
